
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.775 12.678L19.318 4.2a.664.664 0 00-.944 0l-3.59 3.599a.665.665 0 000 .946l.785.8-7.22 2.893a2.665 2.665 0 00-1.65 1.826L4.042 25.007c-.115.454.016.935.345 1.267l1.33 1.333c.26.26.617.4.984.386.106.013.213.013.32 0l10.716-2.666a2.662 2.662 0 001.822-1.6l2.885-7.237.798.786a.665.665 0 00.944 0l3.59-3.599a.666.666 0 000-1zm-10.637 10.01l-8.19 2.04 3.802-3.813a.851.851 0 01.598-.253 1.997 1.997 0 001.995-2 1.997 1.997 0 00-1.995-1.999 1.997 1.997 0 00-1.994 2 .86.86 0 01-.253.6l-3.803 3.812 2.061-8.171 8.284-3.32 2.792 2.8-3.297 8.304z"}})])
          )
        }
      }
    